import {
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";

import { DarkLayout } from "../../account/shared/layouts";

import "./error.page.scss";

export const ErrorPage = () => {
  return (
    <DarkLayout className="error-page">
      <div className="error-page-content">
        <Notification type={NotificationType.error}>
          An error has occurred. Please try reloading the page. <br />
          If this issue persists please contact customer support.
        </Notification>
      </div>
    </DarkLayout>
  );
};
